import get from 'lodash.get';
import { trackEcommerce } from 'dibs-tracking';
import { defaultLocale } from 'dibs-intl/exports/constants';
import { pageTypeConstants as pageTypes } from '../../../constants/pageTypeConstants';
import { ECOMMERCE_ATTRIBUTES } from '../../../constants/attributesConstants';
import { cdnTestEcommerceTracking } from './cdnTestTracking';

const LIST_TRACKING_SEARCH = 'search results listing';
const LIST_TRACKING_BROWSE = 'browse page listing';
const LIST_TRACKING_ATTRIBUTE = 'attribute listing';
const LIST_TRACKING_STOREFRONT = 'storefront listing';

import SV from 'server-vars';

export const NUMBER_OF_PRODUCT_IMPRESSIONS = 20;

const getListType = pageType => {
    const { SEARCH, BROWSE, DEALER } = pageTypes;

    if (pageType === SEARCH) {
        return LIST_TRACKING_SEARCH;
    } else if (pageType === BROWSE) {
        return LIST_TRACKING_BROWSE;
    } else if (ECOMMERCE_ATTRIBUTES.includes(pageType)) {
        return LIST_TRACKING_ATTRIBUTE;
    } else if (pageType === DEALER) {
        return LIST_TRACKING_STOREFRONT;
    } else {
        return `${pageType} listing`;
    }
};

const getProductData = ({ index, item = {}, pageType }) => {
    const {
        serviceId,
        title,
        seller,
        displayInfo = {},
        categoryCode,
        pricing,
        browseUrl,
        contemporaryTrackingString,
    } = item;
    const showSale = get(displayInfo, 'pricing.showSale');
    const showNet = get(displayInfo, 'pricing.showNet');

    let priceType = 'list price';
    let priceKey = 'amount';

    if (showSale) {
        priceKey = 'salePrice';
        priceType = 'saturday sale';
    } else if (showNet) {
        priceKey = 'netPrice';
        priceType = 'net price';
    }

    const convertedAmounts = get(pricing, `${priceKey}.convertedAmountList`) || [];
    const usdPrice = convertedAmounts.find(({ currency }) => currency === 'USD') || {};
    const price = usdPrice.amount || 0;

    return {
        id: serviceId,
        name: SV.get('locale') === defaultLocale ? title : 'n/a',
        position: index + 1, // 1-indexed
        brand: get(seller, 'serviceId'),
        category: browseUrl,
        categoryCode,
        dimension76: priceType,
        dimension83: contemporaryTrackingString,
        price,
        list: getListType(pageType),
        ...cdnTestEcommerceTracking({ item }),
    };
};

export const trackEcommerceProductImpressions = ({ items, pageType, startIndex = 0 }) => {
    const itemProductData = items
        .slice(startIndex, startIndex + NUMBER_OF_PRODUCT_IMPRESSIONS)
        .map(({ node }, index) =>
            getProductData({ item: node, pageType, index: startIndex + index })
        );

    trackEcommerce({
        type: 'productImpression',
        products: itemProductData,
    });
};

export const trackEcommerceProductClick = ({ item, pageType, index }) => {
    trackEcommerce({
        type: 'productClick',
        actionField: {
            list: getListType(pageType),
        },
        products: [getProductData({ item, pageType, index })],
    });
};

// TODO: FINDING-12480 make sure itemFragment below contains all
// information for every function that uses item in this file and
// remove fields from individual components

// export const itemFragment = graphql`
//     fragment ecommerceTracking_item on Item {
//         title
//         serviceId
//         categoryPath
//         contemporaryTrackingString
//         seller {
//             serviceId
//         }
//         displayInfo(buyerId: $userId) @include(if: $isClient) {
//             pricing {
//                 showNet
//                 showSale
//             }
//         }
//         pricing {
//             retailPrice {
//                 amount
//             }
//             netPrice {
//                 amount
//             }
//             salePrice {
//                 amount
//             }
//         }
//     }
// `;
